import React, { Component } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import CircularProgress from "@material-ui/core/CircularProgress";
import AccountBalance from "@material-ui/icons/AccountBalance";
import Receipt from "@material-ui/icons/Receipt";
import Payment from "@material-ui/icons/Payment";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import DataTable, { formatUGX } from "components/DataTable/DataTable.jsx";

import api from "api/index";

const invoiceColumns = [
  { id: "semester", header: "Semester", accessorFn: i => i.semester?.name || "—" },
  { id: "totalAmount", header: "Total Amount (UGX)", accessorFn: i => formatUGX(i.totalAmount), meta: { align: "right" } },
  { id: "balanceDue", header: "Balance Due (UGX)", accessorFn: i => formatUGX(i.balanceDue), meta: { align: "right" } },
  { id: "generated", header: "Generated", accessorFn: i => new Date(i.generatedAt).toLocaleDateString() }
];

const paymentColumns = [
  { id: "amount", header: "Amount (UGX)", accessorFn: p => formatUGX(p.amount), meta: { align: "right" } },
  { id: "method", header: "Method", accessorFn: p => p.method || "—" },
  { id: "reference", header: "Reference", accessorFn: p => p.referenceNo || "—", meta: { variant: "mono" } },
  { id: "date", header: "Date", accessorFn: p => new Date(p.receivedAt).toLocaleDateString() }
];

const styles = {
  statCard: { 
    padding: "20px", 
    borderRadius: "12px", 
    background: "#fff", 
    boxShadow: "0 2px 12px 0 rgba(0,0,0,0.05)",
    display: "flex",
    alignItems: "center",
    gap: "16px",
    border: "1px solid #f1f5f9"
  },
  iconBox: {
    width: "48px",
    height: "48px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  },
  statNum: { fontSize: "18px", fontWeight: 700, color: "#1e293b", margin: 0 },
  statLabel: { fontSize: "12px", color: "#64748b", margin: "2px 0 0" },
  sectionTitle: { color: "#1e293b", fontWeight: 700, fontSize: "16px", margin: "32px 0 16px", display: "flex", alignItems: "center", gap: "8px" },
  emptyState: { textAlign: "center", color: "#94a3b8", padding: "40px", background: "#f8fafc", borderRadius: "12px", border: "1px dashed #e2e8f0" }
};

class PortalFees extends Component {
  state = { summary: null, invoices: [], payments: [], loading: true };

  componentDidMount() {
    this.fetchFees();
  }

  fetchFees = async () => {
    try {
      const res = await api.get("/portal/fees");
      const d = res.data.data || res.data;
      this.setState({ summary: d.summary, invoices: d.invoices || [], payments: d.payments || [], loading: false });
    } catch (e) {
      this.setState({ loading: false });
    }
  };

  render() {
    const { classes } = this.props;
    const { summary, invoices, payments, loading } = this.state;

    if (loading) return <div style={{ textAlign: "center", padding: "100px" }}><CircularProgress /></div>;

    const balance = summary?.balance || 0;

    return (
      <div style={{ padding: "10px" }}>
        <GridContainer>
          <GridItem xs={12} sm={4}>
            <div className={classes.statCard}>
              <div className={classes.iconBox} style={{ background: "#f1f5f9", color: "#475569" }}>
                <Receipt />
              </div>
              <div>
                <p className={classes.statNum}>UGX {(summary?.totalInvoiced || 0).toLocaleString()}</p>
                <p className={classes.statLabel}>Total Invoiced</p>
              </div>
            </div>
          </GridItem>
          <GridItem xs={12} sm={4}>
            <div className={classes.statCard}>
              <div className={classes.iconBox} style={{ background: "#f0fdf4", color: "#16a34a" }}>
                <Payment />
              </div>
              <div>
                <p className={classes.statNum}>UGX {(summary?.totalPaid || 0).toLocaleString()}</p>
                <p className={classes.statLabel}>Total Paid</p>
              </div>
            </div>
          </GridItem>
          <GridItem xs={12} sm={4}>
            <div className={classes.statCard}>
              <div className={classes.iconBox} style={{ background: balance > 0 ? "#fef2f2" : "#f0fdf4", color: balance > 0 ? "#dc2626" : "#16a34a" }}>
                <AccountBalance />
              </div>
              <div>
                <p className={classes.statNum}>UGX {balance.toLocaleString()}</p>
                <p className={classes.statLabel}>Balance Due</p>
              </div>
            </div>
          </GridItem>
        </GridContainer>

        <div style={{ marginTop: "32px" }}>
          <DataTable
            title="Invoices"
            columns={invoiceColumns}
            data={invoices}
            emptyState="No invoices found."
          />
        </div>

        <div style={{ marginTop: "24px" }}>
          <DataTable
            title="Payment History"
            columns={paymentColumns}
            data={payments}
            emptyState="No payments recorded yet."
          />
        </div>
      </div>
    );
  }
}

PortalFees.propTypes = { classes: PropTypes.object.isRequired };
export default withStyles(styles)(PortalFees);
